module.exports = __webpack_public_path__ + "static/services_background-d18b363cc40880f6b850862da3a45b43.png";